















































































































// This component is typically used as a dynamic component inside ModalWrapperComponent
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '@/TokenUser';
import { Alert, alertChannel, alertStatus } from '@/Alert';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_topshot from '../utils_topshot';
import * as utils_tracker from '../utils_tracker';
import { globalUC } from '../UserCache';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import MomentSquareComponent from '@/components/MomentSquareComponent.vue';             // @ is an alias to /src
import { MomentOwned } from '@/MomentOwned';
import { Portfolio } from '@/Portfolio';
import { Account } from '@/Account';
import { Auction, auctionType, paymentType } from '@/Auction';

const FIVE_MINUTES_IN_SEC: number = 300
const ONE_HOUR_IN_SEC: number = 3600
const EIGHT_HOUR_IN_SEC: number = 3600 * 8
const ONE_DAYS_IN_SEC: number = 86400
const THREE_DAYS_IN_SEC: number = 86400 * 3
const FIVE_DAYS_IN_SEC: number = 86400 * 5
const SEVEN_DAYS_IN_SEC: number = 86400 * 7
const TEN_DAYS_IN_SEC: number = 86400 * 10

@Component({
  name: 'AuctionPostForm',
  components: { ModalWrapperComponent, MomentSquareComponent }
})
export default class AuctionPostFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public step: number = 0             // 1 is instructions, 2 is form, 3 is agreement to go through with auction
  public skippedStep1: boolean = false
  public moment: MomentOwned = null
  public portfolio: Portfolio = null
  public account: Account = null
  public auctions: Auction[] = null

  public startingPrice: string = null
  public sellerNote: string = null

  public paypal: boolean = false
  public venmo: boolean = false
  public zelle: boolean = false
  public crypto: boolean = false
  public other: boolean = false

  public auction: Auction = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get collectorScoreForPosting(): number { return Auction.MIN_COLLECTOR_SCORE_TO_POST }
  public get collectorScoreForBidding(): number { return Auction.MIN_COLLECTOR_SCORE_TO_BID }
  public get MAX_SELLER_NOTE(): number { return Auction.MAX_SELLER_NOTE }

  public get cancelButtonText(): string {
    switch (this.step) {
      case 1: return 'Cancel';
      case 2: return 'Back';
      case 3: return 'Back';
    }
  }
  public get okButtonText(): string {
    switch (this.step) {
      case 1: return 'Next';
      // case 2: return 'Next';
      case 2: return 'Post';
      case 3: return 'I Agree';
    }
  }
  public get okButtonDisabled(): boolean {
    switch (this.step) {
      case 1: return false;
      case 2: return (Number(this.startingPrice) === 0 && this.auctionLength.seconds > 300)
      case 3: return false;
    }
  }

  public getPaymentMethods(): paymentType[] {
    const paymentMethods: paymentType[] = []
    if (this.paypal) paymentMethods.push(paymentType.Paypal)
    if (this.venmo) paymentMethods.push(paymentType.Venmo)
    if (this.zelle) paymentMethods.push(paymentType.Zelle)
    if (this.crypto) paymentMethods.push(paymentType.Crypto)
    if (this.other) paymentMethods.push(paymentType.Other)
    return paymentMethods
  }

  public getPaymentMethodsString(): string {
    const paymentMethods: paymentType[] = this.getPaymentMethods()
    let niceString: string = paymentMethods.map((pt) => Auction.getPaymentTypeString(pt)).join(' or ')
    for (let i = 0; i < paymentMethods.length - 2; i++ ) niceString = niceString.replace(' or ', ', ')
    return niceString
  }

  public auctionTypeAndDuration(): string {
    return this.auctionLength.label
  }

  public startingBidString(): string {
    if (this.auctionLength.seconds === FIVE_MINUTES_IN_SEC) return `$${this.moment.getFlashAuctionStartingBidAsNiceString()}`
    return utils_topshot.getNicePossibleDecimalPriceString(Number(this.startingPrice))
  }

  public async resendEmail(): Promise<void> {
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + `/api/auth/resendEmailConfirmationCode`;
      const response: any = await utils.makeGetCall(url);
      if (!response || !response.data) throw(new Error('AuctionPostFormComponent.resendEmail() got null response or null response.data'))

      // something is wrong with the alert
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one

        if (!response.data.verified) utils.toast(this, 'Email Sent', `Please click on the email confirmation sent to ${user.email}.`);
        else utils.toast(this, 'Already Verified', `Your email address, ${user.email}, is already verified.`);

      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not sende email confirmation')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }  

  public showFAQ() {
    (this.$refs.FAQAuctionsComponent as ModalWrapperComponent).show('Auctions FAQ', 'lg', null)
  }

  public auctionLengths: Array<{ label: string, seconds: number }> = [
    { label: '5 minute flash auction', seconds: FIVE_MINUTES_IN_SEC },
    { label: '1 hour auction', seconds: ONE_HOUR_IN_SEC },
    { label: '8 hour auction', seconds: EIGHT_HOUR_IN_SEC },
    { label: '1 day auction', seconds: ONE_DAYS_IN_SEC },
    { label: '3 day auction', seconds: THREE_DAYS_IN_SEC },
    { label: '5 day auction', seconds: FIVE_DAYS_IN_SEC },
    { label: '7 day auction', seconds: SEVEN_DAYS_IN_SEC },
    { label: '10 day auction', seconds: TEN_DAYS_IN_SEC },
  ]
  public auctionLength: { label: string, seconds: number } = this.auctionLengths[0]

  public hasEnoughMoments(): boolean {
    return this.portfolio.numMoments >= 20
  }
  public firstPurchaseOldEnough(): boolean {
   return this.account.daysSinceFirstPurchase() >= 30
  }
  public sufficientCollectorScore(): boolean {
    // if (this.account.username === 'RVG') return true
    return this.account.collectorScore2b.total >= Auction.MIN_COLLECTOR_SCORE_TO_POST
  }

  public auctionPostingRequirementsMet(): boolean {
    if (!this.hasEnoughMoments()) return false
    if (!this.firstPurchaseOldEnough()) return false
    if (!this.sufficientCollectorScore()) return false
    if (!this.user.emailVerified) return false
    return true
  }

  public momentHeldLongEnough(): boolean {
    return this.moment.daysHeld() >= 7
  }

  // Jan 10, 2022: temporary comment out!
  public momentPostingRequirementsMet(): boolean {
    // if (!this.momentHeldLongEnough()) return false
    return true
  }


  public onCancel() {
    switch (this.step) {
      case 1:
        this.$emit('close', null)
        this.clearFields()
        return
      case 2:
        this.step--
        return
      case 3:
        this.step--
        return
    }
  }

  public onOK() {
    switch (this.step) {
      case 1:
        this.step++
        return
      case 2:
        if (this.getPaymentMethods().length === 0) { utils.toast(this, 'Error', 'You must specify at least one acceptable payment method.'); return }
        utils_topshot.setPreferredPaymentTypes(this.getPaymentMethods())

        if (!utils_topshot.getHasReadAuctionFAQ()) {
          utils.toast(this, 'Read FAQ', 'Please read the FAQ before posting for the first time')
          return
        }

        this.step++
        return
      case 3:
        this.post()
        return
    }
  }

  public clearFields() {
    this.startingPrice = null
    this.sellerNote = null
  }

  public async onShow(dynamicProps: any) {
    this.clearFields()

    this.moment = dynamicProps.moment
    this.portfolio = dynamicProps.portfolio
    this.account = dynamicProps.account
    this.auctions = dynamicProps.auctions

    this.step = 1
    if (this.auctions.length > 0 && this.auctionPostingRequirementsMet() && this.momentPostingRequirementsMet() && this.momentHeldLongEnough()) {
      this.skippedStep1 = true
      this.step = 2
    }

    const preferredPaymentTypes: paymentType[] = utils_topshot.getPreferredPaymentTypes()
    if (preferredPaymentTypes) {
      try {
        for (const pt of preferredPaymentTypes) {
          if (pt === paymentType.Paypal) this.paypal = true
          if (pt === paymentType.Venmo) this.venmo = true
          if (pt === paymentType.Zelle) this.zelle = true
          if (pt === paymentType.Crypto) this.crypto = true
          if (pt === paymentType.Other) this.other = true
        }
      } catch (e) {}
    }
  }

  public async post() {
    if (!utils_topshot.getHasReadAuctionFAQ()) {
      utils.toast(this, 'Read FAQ', 'Please read the FAQ before posting for the first time')
      return
    }

    // validate form fields
    let abort: boolean = false

    // fields
    let startingPrice: number
    if (this.auctionLength.seconds <= 300) startingPrice = this.moment.getFlashAuctionStartingBid();
    else startingPrice = Number(this.startingPrice)
    if (isNaN(startingPrice)) { abort = true; utils.toast(this, 'Invalid field', 'Starting price') }
    if (this.sellerNote && this.sellerNote.length > Auction.MAX_SELLER_NOTE) { abort = true; utils.toast(this, 'Invalid field', 'Seller note too long') }

    const type: auctionType = this.auctionLength.seconds <= 300 ? auctionType.Flash : auctionType.Regular

    if (abort) return

    // make POST or PUT call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/topshot/auction';
      const postData: any = { momentID: this.moment.momentID, type, startingPrice, reservePrice: null, durationInSec: this.auctionLength.seconds, noteFromSeller: this.sellerNote, paymentTypes: this.getPaymentMethods() } 
      const response: any = await utils.makePostCall(url, postData)
      if (!response || !response.data) throw(new Error('AuctionPostForm.onOK() got null response or null response.data'))

      // something is wrong
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
      }

      // success
      if (response.data.auction) {
        this.auction = new Auction(response.data.auction)
        utils.toast(this, 'Success', `Auction Posted.`)
        this.$emit('close', this.auction)
        this.clearFields()

        utils_tracker.track(`Auction Created`, { momentID: this.auction.momentID, user: this.user.getIdAsString() })
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not post auction')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // utils_tracker.track(`Auction Form Shown`, {  user: this.user.getIdAsString() })

  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
